



















import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import PostButtonAdd from 'components/presenter/item/forum/PostButtonAdd.vue'
import TopicPosts from 'components/presenter/item/forum/TopicPosts.vue'
import api from 'src/assets/api/gql'
import AttendeeForumTopicGet from 'src/graphql/attendee_forum/AttendeeForumTopicGet.gql'
import AttendeeForumTopicPosts from 'src/graphql/attendee_forum/AttendeeForumTopicPosts.gql'
import { Item, ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    PostButtonAdd,
    TopicPosts
  }
})
export default class AttendeeItemForumTopic extends Vue {
  query = AttendeeForumTopicPosts
  topic: ForumTopic | null = null

  @Prop()
  readonly item!: Item

  @Ref()
  readonly posts!: TopicPosts

  async refresh (done: () => void) {
    const { data: { attendeeForumTopics } } = await api.query({
      query: AttendeeForumTopicGet,
      variables: { id: +this.$route.params.tid }
    })
    const topic = attendeeForumTopics?.nodes.length ? attendeeForumTopics?.nodes[0] : null
    if (topic) {
      this.topic = topic
      this.$nextTick(async () => {
        await this.posts.refresh()
      })
    }
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    done(true)
  }
}
